export default "skymp5-front/d552e3fe8356871582aaeb01a795259e.png";